export const AreTPDetailsKnown = "areThirdPartyDetailsKnown";
export const WhyNoContactDetailsTP = "whyAreThereNoContactDetailsForTheThirdParty";
export const ThirdPartyType = "thirdPartyType";
export const TypeOfProperty = "typeOfProperty";
export const BumpCardGivenToTP = "hasTheBumpCardBeenGivenToTheThirdParty";
export const AreYouAbleTo = "areYouAbleTo";
export const LeaveBumpCardVehicle = "canYouLeaveTheBumpCardOnTheVehicle";
export const LeaveBumpCardReturnVehicle = "canYouReturnToTheVehicleToLeaveTheBumpCard";
export const WhyNot = "whyNot";
export const TPTitle = "thirdPartyTitle";
export const Forename = "forename";
export const Surname = "surname";
export const TPSustainedInjuries = "hasThisThirdPartySustainedInjuries";
export const TypeOfInjury = "typeOfInjury";
export const InjuryDescription = "injuryDescription";
export const Occupation = "occupation";
export const Address = "address";
export const EmailAddress = "email";
export const Telephone1 = "telephone1";
export const Telephone2 = "telephone2";
export const Insurer = "insurer";
export const DidTPAdmitLiability = "didThirdPartyAdmitLiability";
export const TPVehicleTimeOfIncident = "wasThirdPartyInVehicleAtTimeOfIncident";
export const NumOfPersonsInVehicleIncludingDriver = "numberOfPersonsInVehicleIncludingDriver";
export const IsDriverOwnerOfVehicle = "isDriverTheOwnerOfTheVehicle";
export const NotOwnerStateVehicleOwnerName = "ifNotOwnerStateVehicleOwnersName";
export const VehicleType = "vehicleType";
export const VehicleRegistration = "vehicleRegistration";
export const ThirdPartyVehicleRegistration = "TP - VehicleRegistration";
export const VehicleMake = "vehicleMake";
export const VehicleModel = "vehicleModel";
export const VehicleColour = "vehicleColour";
export const IsVehicleDriveable = "isVehicleDriveable";
export const DescriptionOfDamage = "descriptionOfDamage";
export const IsTherePreExistingDamageToTPVehicle = "isTherePreExistingDamageToTheThirdPartyVehicle";
export const ThirdPartyPassengers = "thirdPartyPassengers";
export const ThirdPartyValues = "thirdPartyValues";
export const CmsTpJobId = "cmsTpJobId";
export const JobId = "jobId";
export const ThirdPartyId = "thirdPartyId";
